"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subtitle = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fonts = require("../fonts");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Subtitle = (0, _styledComponents.default)(_fonts.Small)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-top: 5px;\n  display: block;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
exports.Subtitle = Subtitle;